import { Button } from 'ypf-pas-general-ui-components';
import PropTypes from 'prop-types';

const FooterButtonTemplate = ({ name, onClickFunction, onClickExit, isDisabled }) => (
  <>
    <div className="d-flex justify-content-center mb-4 ml-4 ">
      <Button
        label="Salir"
        onClick={onClickExit}
        type="button"
        variant="outline-primary"
        widthButton="70px"
      />
      <Button
        className="mx-5 "
        disabled={isDisabled}
        label={name}
        onClick={onClickFunction}
        type="button"
        variant="primary"
        widthButton="145px"
      />
    </div>
  </>
);

FooterButtonTemplate.propTypes = {
  name: PropTypes.string.isRequired,
  onClickFunction: PropTypes.func.isRequired,
  onClickExit: PropTypes.func.isRequired,
  isDisabled: PropTypes.bool
};

FooterButtonTemplate.defaultProps = {
  isDisabled: false
};

export default FooterButtonTemplate;
